//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SaafHeader, } from '@/common/components/index';
    export default {
      components: {
        SaafHeader
      },
      data () {
        return {

        }
      },
      beforeCreate () {
      },
      mounted () {

      },
      beforeDestroy () {

      },
      methods: {

      }
    }



// WEBPACK FOOTER //
// ./src/common/components/Error404.vue